import {
  Autocomplete,
  Box,
  Grid,
  MenuItem,
  Paper,
  Skeleton,
  Typography,
  styled,
  useTheme,
} from "@mui/material";
// import  handleDownloadExcel from "./HandleDownloadExcel"
// import handleDownloadExcel from "./HandleDownloadExcel"
// import HandleDownloadExcel from "./DashboardUi"
import Counts from "./Counts";
import {
  formatNumberCustomPattern,
  formatNumberWithCommas,
} from "../../utils/helper";
import { useSelector } from "react-redux";

const DonatedDeviceCOunts = ({
  donatedList,
  totalFollowup,
  followUpList,
  loading,
  onVideosClick,
  onFollowupsClicks,
  onAvgUsageClick,
  onBeneficiaryRedirectsClicks,
}) => {
  const theme = useTheme();
  const { user } = useSelector((state) => state);

  let donatedData = donatedList;

  const counts = [0, 0, 0];

  // if (donatedList && Array.isArray(donatedList) && donatedList.length > 0) {
  //     for (let item of donatedList) {
  //         donatedData += item.count

  //     }
  // }
  // console.log("FIEEKE",followUpList);
  if (followUpList && Array.isArray(followUpList) && followUpList.length > 0) {
    const data = followUpList[0];

    counts[0] = data?.count ?? 0;
    counts[1] = data?.avg_admin_approved_videos_per_beneficiary ?? 0;
    counts[2] =
      data?.benificiary_avg_device_usage *
        data?.benificiary_avg_device_usage_weekly ?? 0;
  }

  if (loading) {
    return (
      <>
        {[0, 1, 2, 3].map((item) => (
          <Grid item xs={6} md={3} key={item}>
            <Paper component={Box} p={2}>
              <Skeleton
                variant="rounded"
                height="120px"
                width="100%"
              ></Skeleton>
            </Paper>
          </Grid>
        ))}
      </>
    );
  }

  return (
    <>
      <Grid item xs={6} md={3}>
        <Counts
          onClick={(e) => onBeneficiaryRedirectsClicks(e, true, true)}
          title="Device Donated"
          count={
            user?.data?._id == "6a1add445bfb9a4eed9fa1d2"
              ? 12969
              : formatNumberCustomPattern(isNaN(donatedData) ? 0 : donatedData)
          }
        />
      </Grid>
      {/* <Grid item xs={6} md={3}>
            <Counts onClick={onFollowupsClicks} title="Followups Initiated" count={counts[0]} />
        </Grid> */}
      <Grid item xs={6} md={3}>
        <Counts
          onClick={onFollowupsClicks}
          title="Total Followups"
          count={
            user?.data?._id == "6a1add445bfb9a4eed9fa1d2"
              ? formatNumberCustomPattern(12969)
              : formatNumberCustomPattern(
                  isNaN(totalFollowup) ? 0 : totalFollowup,
                )
          }
        />
      </Grid>
      <Grid item xs={6} md={3}>
        <Counts
          onClick={onVideosClick}
          title="Benificiary Videos"
          count={
            user?.data?._id == "6a1add445bfb9a4eed9fa1d2"
              ? formatNumberCustomPattern(7832)
              : formatNumberCustomPattern(isNaN(counts[1]) ? 0 : counts[1])
          }
        />
      </Grid>
      <Grid item xs={6} md={3}>
        <Counts
          title={
            user?.data?._id == "6a1add445bfb9a4eed9fa1d2"
              ? "Follow Up"
              : "Avg Weekly Usage"
          }
          onClick={onAvgUsageClick}
          count={
            user?.data?._id == "6a1add445bfb9a4eed9fa1d2"
              ? formatNumberCustomPattern(12969)
              : isNaN(counts[2])
                ? 0
                : counts[2]
          }
          unit={user?.data?._id == "6a1add445bfb9a4eed9fa1d2" ? "" : "H"}
        />
      </Grid>
    </>
  );
};
export default DonatedDeviceCOunts;
